import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	completed: {
		id: 'app.program.guideRow.completed',
		defaultMessage: 'Completed',
		description: 'Screen reader label for the check shown on a finished session',
	},
	nextUp: {
		id: 'app.program.guideRow.nextUp',
		defaultMessage: 'Up next',
		description: 'Screen reader label for the ring marking the next session to play',
	},
	nowPlaying: {
		id: 'app.program.guideRow.nowPlaying',
		defaultMessage: 'Now playing',
		description: 'Screen reader label for the animated waveform on the session that is playing',
	},
	paused: {
		id: 'app.program.guideRow.paused',
		defaultMessage: 'Paused',
		description: 'Screen reader label for the resting waveform on the session that is paused',
	},
});
